/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HomeownershipSaleMode } from './HomeownershipSaleMode';
import {
    HomeownershipSaleModeFromJSON,
    HomeownershipSaleModeFromJSONTyped,
    HomeownershipSaleModeToJSON,
} from './HomeownershipSaleMode';

/**
 * 
 * @export
 * @interface HomeownershipSaleBlock
 */
export interface HomeownershipSaleBlock {
    /**
     * 
     * @type {Date}
     * @memberof HomeownershipSaleBlock
     */
    markedAt?: Date;
    /**
     * 
     * @type {HomeownershipSaleMode}
     * @memberof HomeownershipSaleBlock
     */
    mode: HomeownershipSaleMode;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipSaleBlock
     */
    residentResponse?: HomeownershipSaleBlockResidentResponseEnum;
    /**
     * 
     * @type {Date}
     * @memberof HomeownershipSaleBlock
     */
    respondedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipSaleBlock
     */
    lastLookEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof HomeownershipSaleBlock
     */
    windowDays?: number;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipSaleBlock
     */
    discountPct?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipSaleBlock
     */
    splitPct?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipSaleBlock
     */
    lenderRequested?: boolean;
}


/**
 * @export
 */
export const HomeownershipSaleBlockResidentResponseEnum = {
    Interested: 'interested',
    Pass: 'pass'
} as const;
export type HomeownershipSaleBlockResidentResponseEnum = typeof HomeownershipSaleBlockResidentResponseEnum[keyof typeof HomeownershipSaleBlockResidentResponseEnum];


/**
 * Check if a given object implements the HomeownershipSaleBlock interface.
 */
export function instanceOfHomeownershipSaleBlock(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mode" in value;
    isInstance = isInstance && "lastLookEnabled" in value;

    return isInstance;
}

export function HomeownershipSaleBlockFromJSON(json: any): HomeownershipSaleBlock {
    return HomeownershipSaleBlockFromJSONTyped(json, false);
}

export function HomeownershipSaleBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipSaleBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'markedAt': !exists(json, 'marked_at') ? undefined : (new Date(json['marked_at'])),
        'mode': HomeownershipSaleModeFromJSON(json['mode']),
        'residentResponse': !exists(json, 'resident_response') ? undefined : json['resident_response'],
        'respondedAt': !exists(json, 'responded_at') ? undefined : (new Date(json['responded_at'])),
        'lastLookEnabled': json['last_look_enabled'],
        'windowDays': !exists(json, 'window_days') ? undefined : json['window_days'],
        'discountPct': !exists(json, 'discount_pct') ? undefined : json['discount_pct'],
        'splitPct': !exists(json, 'split_pct') ? undefined : json['split_pct'],
        'lenderRequested': !exists(json, 'lender_requested') ? undefined : json['lender_requested'],
    };
}

export function HomeownershipSaleBlockToJSON(value?: HomeownershipSaleBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'marked_at': value.markedAt === undefined ? undefined : (value.markedAt.toISOString()),
        'mode': HomeownershipSaleModeToJSON(value.mode),
        'resident_response': value.residentResponse,
        'responded_at': value.respondedAt === undefined ? undefined : (value.respondedAt.toISOString()),
        'last_look_enabled': value.lastLookEnabled,
        'window_days': value.windowDays,
        'discount_pct': value.discountPct,
        'split_pct': value.splitPct,
        'lender_requested': value.lenderRequested,
    };
}

